<template>
  <div class="wechat-pay-log">
    <el-card>
      <div slot="header" class="card-header">
        <span>{{ pageTitle }}</span>
        <div>
          <el-button type="info" size="small" icon="el-icon-data-line" @click="showStatistics">
            统计信息
          </el-button>
        </div>
      </div>

      <!-- 搜索区域 -->
      <el-form :inline="true" class="search-form">
        <el-form-item label="日志类型">
          <el-select v-model="searchForm.logType" placeholder="全部" clearable style="width: 150px">
            <el-option label="创建订单" value="CREATE_ORDER"></el-option>
            <el-option label="支付回调" value="NOTIFY"></el-option>
            <el-option label="查询订单" value="QUERY"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" clearable style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="交易状态">
          <el-select v-model="searchForm.tradeState" placeholder="全部" clearable style="width: 150px">
            <el-option label="支付成功" value="SUCCESS"></el-option>
            <el-option label="未支付" value="NOTPAY"></el-option>
            <el-option label="已关闭" value="CLOSED"></el-option>
            <el-option label="转入退款" value="REFUND"></el-option>
            <el-option label="已撤销" value="REVOKED"></el-option>
            <el-option label="用户支付中" value="USERPAYING"></el-option>
            <el-option label="支付失败" value="PAYERROR"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 380px">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 日志列表 -->
      <el-table 
        :data="logList" 
        v-loading="loading"
        stripe
        border
        style="width: 100%">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="logType" label="日志类型" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.logType === 'CREATE_ORDER'" type="success" size="small">创建订单</el-tag>
            <el-tag v-else-if="scope.row.logType === 'NOTIFY'" type="warning" size="small">支付回调</el-tag>
            <el-tag v-else-if="scope.row.logType === 'QUERY'" type="info" size="small">查询订单</el-tag>
            <el-tag v-else size="small">{{ scope.row.logType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="200"></el-table-column>
        <el-table-column prop="transactionId" label="微信订单号" width="200"></el-table-column>
        <el-table-column prop="username" label="用户名" width="120"></el-table-column>
        <el-table-column prop="amount" label="金额(元)" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.amount" style="color: #f56c6c; font-weight: bold;">
              ¥{{ scope.row.amount }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="tradeState" label="交易状态" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.tradeState === 'SUCCESS'" type="success" size="small">支付成功</el-tag>
            <el-tag v-else-if="scope.row.tradeState === 'NOTPAY'" type="info" size="small">未支付</el-tag>
            <el-tag v-else-if="scope.row.tradeState === 'CLOSED'" type="info" size="small">已关闭</el-tag>
            <el-tag v-else-if="scope.row.tradeState === 'REFUND'" type="warning" size="small">转入退款</el-tag>
            <el-tag v-else-if="scope.row.tradeState === 'USERPAYING'" type="warning" size="small">支付中</el-tag>
            <el-tag v-else-if="scope.row.tradeState === 'PAYERROR'" type="danger" size="small">支付失败</el-tag>
            <el-tag v-else-if="scope.row.tradeState" size="small">{{ scope.row.tradeState }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="处理状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success" size="small">成功</el-tag>
            <el-tag v-else type="danger" size="small">失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="160">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleViewDetail(scope.row)">查看详情</el-button>
            <el-button 
              type="text" 
              size="small" 
              style="color: #f56c6c" 
              @click="handleDelete(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; margin-top: 20px;">
      </el-pagination>
    </el-card>

    <!-- 日志详情对话框 -->
    <el-dialog 
      title="日志详情" 
      :visible.sync="detailVisible" 
      width="900px">
      <div v-if="currentLog" class="log-detail">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="日志ID">{{ currentLog.id }}</el-descriptions-item>
          <el-descriptions-item label="日志类型">
            <el-tag v-if="currentLog.logType === 'CREATE_ORDER'" type="success">创建订单</el-tag>
            <el-tag v-else-if="currentLog.logType === 'NOTIFY'" type="warning">支付回调</el-tag>
            <el-tag v-else-if="currentLog.logType === 'QUERY'" type="info">查询订单</el-tag>
            <el-tag v-else>{{ currentLog.logType }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="订单号">{{ currentLog.orderNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="微信订单号">{{ currentLog.transactionId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="用户ID">{{ currentLog.userId || '-' }}</el-descriptions-item>
          <el-descriptions-item label="用户名">{{ currentLog.username || '-' }}</el-descriptions-item>
          <el-descriptions-item label="支付金额">
            <span v-if="currentLog.amount" style="color: #f56c6c; font-weight: bold;">
              ¥{{ currentLog.amount }}
            </span>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="交易状态">
            <el-tag v-if="currentLog.tradeState === 'SUCCESS'" type="success">支付成功</el-tag>
            <el-tag v-else-if="currentLog.tradeState" type="info">{{ currentLog.tradeState }}</el-tag>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="IP地址">{{ currentLog.ipAddress || '-' }}</el-descriptions-item>
          <el-descriptions-item label="User-Agent" :span="2">
            <div style="max-width: 100%; overflow-wrap: break-word;">
              {{ currentLog.userAgent || '-' }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="处理状态">
            <el-tag v-if="currentLog.status === 1" type="success">成功</el-tag>
            <el-tag v-else type="danger">失败</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="执行时长">
            {{ currentLog.executionTime ? currentLog.executionTime + 'ms' : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="创建时间" :span="2">{{ formatDate(currentLog.createdAt) }}</el-descriptions-item>
          <el-descriptions-item label="错误信息" :span="2" v-if="currentLog.errorMsg">
            <div style="color: #f56c6c; max-width: 100%; overflow-wrap: break-word;">
              {{ currentLog.errorMsg }}
            </div>
          </el-descriptions-item>
        </el-descriptions>

        <!-- 请求数据 -->
        <div v-if="currentLog.requestData" style="margin-top: 20px;">
          <h4>请求数据：</h4>
          <el-input
            type="textarea"
            :value="formatJson(currentLog.requestData)"
            :rows="6"
            readonly
            style="font-family: monospace;">
          </el-input>
        </div>

        <!-- 响应数据 -->
        <div v-if="currentLog.responseData" style="margin-top: 20px;">
          <h4>响应数据：</h4>
          <el-input
            type="textarea"
            :value="formatJson(currentLog.responseData)"
            :rows="6"
            readonly
            style="font-family: monospace;">
          </el-input>
        </div>

        <!-- 回调数据 -->
        <div v-if="currentLog.callbackData" style="margin-top: 20px;">
          <h4>回调数据：</h4>
          <el-input
            type="textarea"
            :value="formatJson(currentLog.callbackData)"
            :rows="6"
            readonly
            style="font-family: monospace;">
          </el-input>
        </div>
      </div>
    </el-dialog>

    <!-- 统计信息对话框 -->
    <el-dialog 
      title="统计信息" 
      :visible.sync="statisticsVisible" 
      width="600px">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="总日志数">
          <span style="font-size: 20px; font-weight: bold; color: #409EFF;">
            {{ statistics.totalCount || 0 }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="创建订单">
          <el-tag type="success">{{ statistics.createOrderCount || 0 }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="支付回调">
          <el-tag type="warning">{{ statistics.notifyCount || 0 }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="查询订单">
          <el-tag type="info">{{ statistics.queryCount || 0 }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="支付成功">
          <el-tag type="success">{{ statistics.successCount || 0 }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="处理失败">
          <el-tag type="danger">{{ statistics.failCount || 0 }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="总交易金额" :span="2">
          <span style="font-size: 24px; font-weight: bold; color: #f56c6c;">
            ¥{{ statistics.totalAmount || 0 }}
          </span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'WechatPayLog',
  data() {
    return {
      pageTitle: '微信支付日志',
      searchForm: {
        logType: '',
        orderNo: '',
        tradeState: ''
      },
      dateRange: null,
      logList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      detailVisible: false,
      currentLog: null,
      statisticsVisible: false,
      statistics: {}
    }
  },
  mounted() {
    this.loadPageTitle()
    this.loadData()
  },
  methods: {
    async loadPageTitle() {
      try {
        const menuData = localStorage.getItem('admin_menu_data')
        if (menuData) {
          const menus = JSON.parse(menuData)
          const allMenus = menus.menus || []
          const currentMenu = allMenus.find(m => m.url === this.$route.path)
          if (currentMenu) {
            this.pageTitle = currentMenu.name
          }
        }
      } catch (error) {
        console.error('加载页面标题失败:', error)
      }
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          logType: this.searchForm.logType,
          orderNo: this.searchForm.orderNo,
          tradeState: this.searchForm.tradeState
        }
        
        if (this.dateRange && this.dateRange.length === 2) {
          params.startTime = this.dateRange[0]
          params.endTime = this.dateRange[1]
        }
        
        const res = await this.$axios.get('/admin/wechat-pay-log/list', { params })
        if (res.data.code === 200) {
          this.logList = res.data.data.records
          this.total = res.data.data.total
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = {
        logType: '',
        orderNo: '',
        tradeState: ''
      }
      this.dateRange = null
      this.currentPage = 1
      this.loadData()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadData()
    },
    handleViewDetail(row) {
      this.currentLog = row
      this.detailVisible = true
    },
    async handleDelete(id) {
      try {
        await this.$confirm('确定要删除这条日志吗？', '提示', {
          type: 'warning'
        })
        
        const res = await this.$axios.delete(`/admin/wechat-pay-log/${id}`)
        if (res.data.code === 200) {
          this.$message.success('删除成功')
          this.loadData()
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
    async showStatistics() {
      try {
        const res = await this.$axios.get('/admin/wechat-pay-log/statistics')
        if (res.data.code === 200) {
          this.statistics = res.data.data
          this.statisticsVisible = true
        }
      } catch (error) {
        this.$message.error('获取统计信息失败')
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      return dateStr.replace('T', ' ')
    },
    formatJson(jsonStr) {
      try {
        const obj = JSON.parse(jsonStr)
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return jsonStr
      }
    }
  }
}
</script>

<style scoped>
.wechat-pay-log {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-form {
  margin-bottom: 20px;
}

.log-detail h4 {
  margin: 0 0 10px 0;
  color: #303133;
}
</style>
